module.exports = __webpack_public_path__ + "img/mingbai4_2f6d990d6.png";